export default __webpack_public_path__ + "media/images/svg/cta_arrow-17cbbd5dd0a66ba5aa538ea7f44f94ea.svg";